import { ArrowBackIosNew, ArrowForwardIos, QuizOutlined } from '@mui/icons-material';
import { IconButton, Box, Typography } from '@mui/material';
import React, { Fragment, useState } from 'react';

import OverwatchModal from '../OverwatchModal';

import MsDocumentViewer from './MsDocumentsViewer';

import { arrayLength } from '@/utils/helperFunctions';

interface DocumentsViewerProps {
  handleClose: () => void;
  urls: string[];
}

const DocumentsViewerModal: React.FC<DocumentsViewerProps> = ({ handleClose, urls }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const handlePrev = () => {
    if (currentIndex > 0) setCurrentIndex(currentIndex - 1);
  };

  const handleNext = () => {
    if (currentIndex < arrayLength(urls) - 1) setCurrentIndex(currentIndex + 1);
  };

  return (
    <OverwatchModal
      size="md"
      title="View Documents"
      handleClose={handleClose}
      primaryButtonText="Close"
      primaryButtonAction={handleClose}
      secondaryButton={<Fragment />}
    >
      {arrayLength(urls) > 0 ? (
        <Box>
          <MsDocumentViewer key={urls[currentIndex]} url={urls[currentIndex]} />

          {arrayLength(urls) > 1 && (
            <Box display="flex" alignItems="center" justifyContent="center" mb={2}>
              <IconButton
                onClick={handlePrev}
                disabled={currentIndex === 0}
                aria-label="Previous Document"
                size="small"
              >
                <ArrowBackIosNew fontSize="small" />
              </IconButton>
              <Typography variant="body2" sx={{ mx: 2 }}>
                {currentIndex + 1} / {urls.length}
              </Typography>
              <IconButton
                onClick={handleNext}
                disabled={currentIndex === urls.length - 1}
                aria-label="Next Document"
                size="small"
              >
                <ArrowForwardIos fontSize="small" />
              </IconButton>
            </Box>
          )}
        </Box>
      ) : (
        <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center">
          <QuizOutlined color="disabled" sx={{ width: 80, height: 80, opacity: 0.4, mb: 1 }} />
          <Typography align="center">No documents available.</Typography>
        </Box>
      )}
    </OverwatchModal>
  );
};

export default DocumentsViewerModal;
